import capitalWords from '@/plugins/filters/capitalWords'

export default function (value) {
  if (typeof value === 'string') {
    return capitalWords(value.replaceAll('_', ' '))
  }
}
